import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { ConnectionStatus } from './ConnectionStatus/ConnectionStatus';
import { MobileBottomNav } from './MobileBottomNav/MobileBottomNav';
import { MobileLayoutRoot, MobileContent } from './MobileLayout.styles';

export const MobileLayout: React.FC = () => {
  const location = useLocation();

  // Hide bottom nav on service detail page
  const isServiceDetailPage = /^\/mobile\/services\/\d+/.test(location.pathname);

  return (
    <MobileLayoutRoot>
      <ConnectionStatus />
      <MobileContent>
        <Outlet />
      </MobileContent>
      {!isServiceDetailPage && <MobileBottomNav />}
    </MobileLayoutRoot>
  );
};
